import { CssBaseline } from "@mui/material";
import { ConnectedRouter } from "connected-react-router";
import SnackbarProviderExtended from "./components/mui/messages/snackbarProviderExtended/snackbarProviderExtended.jsx";
import { PermissionsModule } from "./modules/permission";
import { IssuesModule } from "./modules/issues";

import Main from "./pages/main/main.jsx";

import history from './store/history'

import { loadModules } from "./store/loadModule";
import ThemeCustomization from "./themes/index.jsx";
import './App.css'

export const ENABLED_MODULES = loadModules([PermissionsModule, IssuesModule])
export const ROUTES = ENABLED_MODULES.loadRoutes()

function App() {
	return (
		<ThemeCustomization>
			<SnackbarProviderExtended>
				<ConnectedRouter history={history}>
					<CssBaseline/>
					<Main/>
				</ConnectedRouter>
			</SnackbarProviderExtended>
		</ThemeCustomization>
	)
}

export default App
